import { EnumSchema } from '../metadata-schema';

export const Bekostigingstype: EnumSchema = {
	"type": "string",
	"title": "Bekostigingstype",
	"enum": [
		"Standaard",
		"NietBekostigbaar",
		"ExternOnderwijs"
	]
};
